import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  TextField,
  Select,
  MenuItem,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  FormControl,
  InputAdornment,
  Checkbox,
  ListItemText,
  InputLabel,
  OutlinedInput,
  Tooltip,
  Box,
  CircularProgress,
  Divider,
} from "@material-ui/core";
import { ArrowBack, Search } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Clear, Refresh } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import { Autocomplete } from "@material-ui/lab";
//import jwtDecode from "jwt-decode";
import axios from "axios";
import { appUrl } from "../../../../../utils/config";
import { cmoMembersList } from "../../../containers/actions/pharmaCo/purchaseOrderActions";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import usePrevious from "../../helpers/previousProps";
import { fetchPurchaseOrdersFilters } from "../../../containers/actions/common/purchaseOrderAction";

const useStyles = makeStyles((theme) => ({
  filterContainer: {
    marginBottom: theme.spacing(2),
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "center",
  },
  root: {
    paddingLeft: 0, // Removes left padding
    paddingRight: 0, // Optional: Removes right padding too
  },
  filterContainer: {
    marginBottom: theme.spacing(2),
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "center",
    // paddingLeft: theme.spacing(2), // Adjust spacing as needed
  },
  table: {
    border: "1px solid #ccc",
  },
  header: {
    backgroundColor: "#FFE5CC",
    fontWeight: "bold",
  },
  button: {
    backgroundColor: "#FF6F00",
    color: "white",
    textTransform: "none",
    borderRadius: "10px",
  },
  clearFilters: {
    cursor: "pointer",
    color: "#007BFF",
    textDecoration: "underline",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    cursor: "pointer",
  },
  formControl: {
    minWidth: 150,
  },
  searchIcon: {
    color: "#FF6F00",
  },
  selectInput: {
    display: "flex",
    alignItems: "center",
  },
  multiSelect: {
    maxWidth: 150,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  inputBaseRoot: {
    height: "40px",
  },
}));

// const data = [
//   { month: "December", otif: 95 },
// //   { month: "November", otif: 96 },
// //   { month: "October", otif: 96 },
// //   { month: "September", otif: 95 },
// //   { month: "July", otif: 95 },
// //   { month: "June", otif: 94 },
// //   { month: "May", otif: 96 },
// //   { month: "April", otif: 98 },
// //   { month: "March", otif: 96 },
// //   { month: "February", otif: 92 },
// //   { month: "January", otif: 92 },
// ];

// const plantIdOptions = [
//   {
//     plantType: "Receiving plant",
//     formulationSubType: "Ointments and creams",
//     drugType: "Small Molecules",
//     supplyType: "Commercial (Product ID)",
//     manufacturingType: "Intermediates and API (Drug Substance)",
//     vendorMosymphonyID: 2,
//     plantCode: "L553",
//     brandOwnerMosymphonyID: 1,
//     vendorName: "Maeken",
//   },
//   {
//     plantType: "Supplying plant",
//     formulationSubType: "Oral Solid dosage",
//     drugType: "Biologics",
//     supplyType: "Clinical (Compound ID)",
//     manufacturingType: "Finished Dosage Form",
//     vendorMosymphonyID: 3,
//     plantCode: "L122",
//     brandOwnerMosymphonyID: 1,
//     vendorName: "Zenpharm",
//   },
//   {
//     plantType: "Receiving plant",
//     formulationSubType: "Oral Liquid dosage",
//     drugType: "Small Molecules",
//     supplyType: "Commercial (Product ID)",
//     manufacturingType: "Packaging",
//     vendorMosymphonyID: 2,
//     plantCode: "L789",
//     brandOwnerMosymphonyID: 1,
//     vendorName: "Pharmatech",
//   },
//   {
//     plantType: "Supplying plant",
//     formulationSubType: "Parenterals, inhalers, opthalamics",
//     drugType: "Biologics",
//     supplyType: "Clinical (Compound ID)",
//     manufacturingType: "Intermediates and API (Drug Substance)",
//     vendorMosymphonyID: 3,
//     plantCode: "L345",
//     brandOwnerMosymphonyID: 1,
//     vendorName: "BioSolutions",
//   },
// ];

// const plannerOptions = [
//   {
//     saasUserID: 1,
//     emailID: "sanjay.kuberkar@schrocken.com",
//     organization_ids: [2, 3],
//     name: "Jeffrey Wilson",
//     roleName: "Admin",
//   },
//   {
//     saasUserID: 5,
//     emailID: "POwnbey@quentelle.com",
//     organization_ids: [2],
//     name: "Phil Ownby",
//     roleName: "Marketing Manager",
//   },
//   {
//     saasUserID: 11,
//     emailID: "varun.tiwari.28@gmail.com",
//     organization_ids: [3],
//     name: "Varun Tiwari",
//     roleName: "External Manufacturing Service Manager",
//   },
// ];

const OTIFTrendReport = (props) => {
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const [showReport, setShowReport] = useState(false);

  const [data, setData] = useState([]); // Store API response data

  const history = useHistory(); // Initialize history for navigation
  const [selectedPlantIdList, setSelectedPlantIdList] = useState([]);
  const [plantList, setPlantList] = useState([]);
  const [SelectedCMOList, setSelectedCMOList] = useState([]);
  const [selectedPlannerList, setSelectedPlannerList] = useState([]);
  const [plannerList, setPlannerList] = useState([]);
  const [searchField, setSearchField] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  const [error, setError] = useState(null);
  const [searchSelectValue, setSearchSelectValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [plantIdOptions, setPlantIdOptions] = useState([])
  const [plannerOptions, setPlannerOptions] = useState([]);
  const [allReceivingPlants, setAllReceivingPlants] = useState([]);

  // const [plantId, setPlantId] = useState([]);

  const [supplyTypes, setSupplyTypes] = useState([])
 
   const [drugTypes, setDrugTypes] = useState([])
 
  const [plantTypes, setPlantTypes] = useState([])
  
  const [filteredVendorMosymphonyIDList, setFilteredVendorMosymphonyIDList] = useState([]);


  const purchaseOrderFilter = useSelector((state) =>
      state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters?.status
        ? state.pcmp.common?.purchaseOrder?.purchaseOrderDetailsFilters
        : {}
  );
  
  let cmoMemberWithId = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );

  
  useEffect(() => {
    dispatch(fetchPurchaseOrdersFilters());
  }, [])

  let previousPurchaseOrderFilter = usePrevious(purchaseOrderFilter)

  
  useEffect(() => {
      if (
        JSON.stringify(purchaseOrderFilter) !==
        JSON.stringify(previousPurchaseOrderFilter)
      ) {
        if (purchaseOrderFilter?.save_filter_options && typeof purchaseOrderFilter?.save_filter_options === "object") {

          let savedFilter = purchaseOrderFilter?.save_filter_options
          
          setSelectedPlantIdList(savedFilter?.plantListFilter && Array.isArray(savedFilter?.plantListFilter)
    ? savedFilter?.plantListFilter
    : []);
 setSelectedCMOList(savedFilter?.cmoListFilter && Array.isArray(savedFilter?.cmoListFilter)
    ? savedFilter?.cmoListFilter
    : []);
    setSelectedPlannerList(savedFilter?.plannerUserId && Array.isArray(savedFilter?.plannerUserId)
    ? savedFilter?.plannerUserId
    : []);
    
    let filteredPlannerList = savedFilter?.plannerUserId && Array.isArray(savedFilter?.plannerUserId)
    ? savedFilter?.plannerUserId
      : []
    
    let filteredCMOList = savedFilter?.cmoListFilter && Array.isArray(savedFilter?.cmoListFilter)
      ? savedFilter?.cmoListFilter
      : [];
    
    filteredPlannerList.forEach((val) => {
        if (plannerOptions.filter((val1) => val1.saasUserID === val).length > 0) {
          let orgIds = plannerOptions.filter((val1) => val1.saasUserID === val)[0].organization_ids
          filteredCMOList = [...new Set([...orgIds, ...filteredCMOList])];
        }
      })
    
          
    setFilteredVendorMosymphonyIDList(filteredCMOList);
        }        
      }
  }, [previousPurchaseOrderFilter, purchaseOrderFilter]);

  const clearFilters = () => {
    setShowReport(false);
    // Reset dropdown selections
    setSelectedCMOList([]); // Reset CMO dropdown
    setSelectedPlantIdList([]); // Reset Plant ID dropdown
    setSelectedPlannerList([]); // Reset Planner dropdown
    setFilteredVendorMosymphonyIDList([])

    // Reset search field and search value
    setSearchField("all"); // Reset to default "Select search by"
    setSearchValue(""); // Clear the search value
    setSearchSelectValue(null); // Reset search select value for Autocomplete
    setData([])

    // Add any other state reset logic for additional fields if needed
  };

  function handleSearchValue(e) {
    setSearchValue(e.target.value);
  }
  function handleSearchClick() {
    handleViewReport();
  }

   const handleSelectTypeValue = (value) => {
    if (typeof value === 'object') {
    if (searchField === 'Supply type') {
        let type = plantIdOptions.filter((val) => val.supplyTypeName === value.supplyTypeID)
      setPlantList(type)
      
    } else if (searchField === 'Drug type') {
      let type =  plantIdOptions.filter((val)=> val.drugTypeName === value.drugTypeID)
      setPlantList(type)
    } else if (searchField === 'Plant type') {
      let type = plantIdOptions.filter((val)=> val.plantTypeName === value.plantTypeID)
      setPlantList(type)
    }
      
    } else {
      setPlantList(plantIdOptions)
    }
  }

  const handleSearchField = (event) => {
    // setCurrentPage(1);
    setSearchField(event.target.value);
    setSearchValue("");
    setSearchSelectValue(null);
  };


  const handleViewReport = () => {
    // const plannerEmailIDs = selectedPlannerList.map((plannerID) => {
    //   const planner = plannerOptions.find((option) => option.saasUserID === plannerID);
    //   return planner ? planner.email : null;
    // }).filter(email => email !== null);

    // const requestPayload = {
    //   searchField: searchField === "all" ? "" : searchField, // Replace with actual search field value
    //   searchValue: searchValue, // Replace with actual search value
    //   plantCodeList: selectedPlantIdList.length > 0
    //   ? selectedPlantIdList
    //   : [], // Example plant code list
    //   vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
    //   deliveryCompletionIndicator: location.state?.deliveryCompletionIndicator,
    //   plannerEmailIDs: plannerEmailIDs
    // };
    const requestPayload = {
  searchField: searchField === "all" ? "" : searchField,
  searchValue: typeof searchValue === "string" && searchValue.trim() !== searchValue ? searchValue.trim() : searchValue,
  plantCodeList: selectedPlantIdList.length > 0 ? selectedPlantIdList : [],
  vendorMosymphonyIDList: filteredVendorMosymphonyIDList,
  deliveryCompletionIndicator: location.state?.deliveryCompletionIndicator,
  plannerSaasUserIDs: selectedPlannerList
};

    const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAvgOTIFTrendReports
  `;
    setShowReport(true);
    setLoading(true);
    setError(null);
    setData([]); // Clear previous data

    axios
      .post(url, requestPayload)
      .then((res) => {
        setLoading(false);
        //console.log(res)
        if (res.data.status) {
          setData(res.data?.data?.slDetailsList || []); // Ensure data is set properly
        } else {
          setError("Something went wrong. Please try again later.");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
        setError("Something went wrong. Please try again later.");
      });
  };

  const handleBack = () => {
    history.goBack(); // Navigate to the previous page
  };

  const handleChangeCMOList = (event) => {
    const value = event.target.value;
    
    if (value.includes("All")) {
      setSelectedCMOList(SelectedCMOList.length === cmoMemberWithId.length ? [] : cmoMemberWithId.map((val) => val.organization_id));
      setFilteredVendorMosymphonyIDList(SelectedCMOList.length === cmoMemberWithId.length ? [] : cmoMemberWithId.map((val) => val.organization_id))
      setPlantList(plantIdOptions.filter((val) => cmoMemberWithId.map((val) => val.organization_id).includes(val.vendorMosymphonyID)))
      setPlannerList(plannerOptions.filter((val)=> val?.organization_ids ? val.organization_ids.some((item) => cmoMemberWithId.map((val) => val.organization_id).includes(item)) : false))
    } else {
      setSelectedCMOList(value);
      setFilteredVendorMosymphonyIDList(value)
      if (value.length > 0) {
        setPlantList(plantIdOptions.filter((val) => value.includes(val.vendorMosymphonyID)))
        setPlannerList(plannerOptions.filter((val) => val?.organization_ids ? val?.organization_ids.some((item) => value.includes(item)) : false))
      } else {
        setPlantList(plantIdOptions)
        setPlannerList(plannerOptions)
      }
      
      
      if (selectedPlantIdList.length > 0 && value.length > 0) {
        setSelectedPlantIdList(selectedPlantIdList.filter(val => {
          const match = plantIdOptions.find(val1 => val === val1.plantCode);
          return match ? value.includes(match.vendorMosymphonyID) : false;
        }))
      }

    }
  };
  const getDisplayCMOFilterValue = () => {
    if (SelectedCMOList.length === cmoMemberWithId.length) return "All";
    if (SelectedCMOList.length === 1) {
      const selectedCMO = cmoMemberWithId.find(
        (option) => option.organization_id === SelectedCMOList[0]
      );
      return selectedCMO ? selectedCMO.organization_name : "Multiple selection";
    }
    return "Multiple selection";
  };


  const handleChangePlantIdList = (event) => {
    const value = event.target.value;
    
    if (value.includes("All")) {
      setSelectedPlantIdList(selectedPlantIdList.length === plantList.length ? [] : plantList.map((val)=> val.plantCode));
    } else {
      setSelectedPlantIdList(value);
    }
  };

  const getDisplayPlantIDValue = () => {
    if (selectedPlantIdList.length === plantList.length) return "All";
    if (selectedPlantIdList.length === 1) {
      const selectedPlant = plantList.find(
        (option) => option.plantCode === selectedPlantIdList[0]
      );
      return selectedPlant ? selectedPlant.plantCode : "Multiple selection";
    }
    return "Multiple selection";
  };

  const handleChangePlannerList = (event) => {
    const value = event.target.value;
    //console.log(value);

    if (value.includes("All")) {
      setSelectedPlannerList(
        selectedPlannerList.length === plannerList.length
          ? []
          : plannerList.map((val) => val.saasUserID)
      );

      
      if (SelectedCMOList.length > 0) {
        setFilteredVendorMosymphonyIDList(SelectedCMOList)
      } else {
        let cmoList = []
        plannerList.forEach((val) => {
          let orgIds = val.organization_ids
          cmoList = [...new Set([...orgIds, ...cmoList, ...SelectedCMOList])];
        })
        setFilteredVendorMosymphonyIDList(cmoList)
      }
    } else {
      setSelectedPlannerList(value);
      if (SelectedCMOList.length > 0) {
        setFilteredVendorMosymphonyIDList(SelectedCMOList)
      } else {
        let cmoList = []
        value.forEach((val) => {
          if (plannerList.filter((val1) => val1.saasUserID === val).length > 0) {
            let orgIds = plannerList.filter((val1) => val1.saasUserID === val)[0].organization_ids
          cmoList = [...new Set([...orgIds, ...cmoList, ...SelectedCMOList])];
          }
        })
        setFilteredVendorMosymphonyIDList(cmoList)
      }
    }
  };

  const getDisplayPlannerValue = () => {
    if (selectedPlannerList.length === plannerList.length) return "All";
  if (selectedPlannerList.length === 1) {
    const selectedPlanner = plannerList.find(
      (option) => option.saasUserID === selectedPlannerList[0]
    );
    return selectedPlanner ? selectedPlanner.name : "Multiple selection";
  }
  return "Multiple selection";
  };

  function handleClearSearch() {
    if (["Supply type", "Drug type", "Plant type"].includes(searchField)) {
      if (SelectedCMOList.length > 0) {
        setPlantList(plantIdOptions.filter((val) => SelectedCMOList.includes(val.vendorMosymphonyID)))
      } else {
        setPlantList(plantIdOptions);
      }
      
    }
    setSearchValue("");
    setLoading(true);
    setSearchSelectValue(null);
    handleViewReport()
  }

  useEffect(() => {
      let { collabType, ecosystemId, organizationName, roleName } = localStorage;
      if (collabType !== "CMO") {
        dispatch(
          cmoMembersList({
            collabType: collabType,
            roleName: roleName,
            organizationName: organizationName,
            ecosystemId: ecosystemId,
          })
        );
      }
      axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantSupplyTypes/true`)
      .then((res) => {
        //console.log(res.data?.data?.status)
        if (res.data?.data?.status) {
          //console.log(res.data?.data?.supplyTypeList)
          setSupplyTypes(res.data?.data?.supplyTypeList)
        }
      })
      .catch((err) => { });
    
      axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantDrugTypes/true`)
      .then((res) => {
        //console.log(res.data?.data?.status)
        if (res.data?.data?.status) {
          //console.log(res.data?.data?.drugTypeList)
          setDrugTypes(res.data?.data?.drugTypeList)
        }
      })
      .catch((err) => { });
    
      axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlantTypes/true`)
      .then((res) => {
        //console.log(res.data?.data?.status)
        if (res.data?.data?.status) {
          //console.log(res.data?.data?.plantTypeList)
          setPlantTypes(res.data?.data?.plantTypeList)
        }
      })
      .catch((err) => { });
    
      // axios
      // .get(
      //   `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllVendorPlants`)
      // .then((res) => {
      //   console.log(res.data?.status)
      //   if (res.data?.status) {
      //     console.log(res.data?.vendorPlantDetails)
      //     setPlantList(res.data?.vendorPlantDetails ? res.data?.vendorPlantDetails : [])
      //     setPlantIdOptions(res.data?.vendorPlantDetails ? res.data?.vendorPlantDetails : [])
      //   }
      // })
      // .catch((err) => { console.log(err) });
      let isMounted = true;
      axios
        .get(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllReceivingPlantIDsAndStorageLocationIDs/all`
        )
        .then((res) => {
          if (isMounted && res.data?.vendorOrgLevelData) {
            // Flatten receivingPlantIDs from all vendorOrgLevelData objects
            const plantIds = res.data.vendorOrgLevelData
              .flatMap((item) => item.receivingPlantIDs || [])
              .filter((id) => id); // Remove null/undefined
    
            // Map to the format expected by plantList and plantIdOptions
            const formattedPlants = plantIds.map((id) => ({
              plantCode: id,
              vendorMosymphonyID: res.data.vendorOrgLevelData.find((item) =>
                item.receivingPlantIDs.includes(id)
              )?.vendorMosymphonyID,
              supplyTypeName:
                supplyTypes.find((st) => st.supplyTypeID === id)?.supplyTypeName || "",
              drugTypeName:
                drugTypes.find((dt) => dt.drugTypeID === id)?.drugTypeName || "",
              plantTypeName:
                plantTypes.find((pt) => pt.plantTypeID === id)?.plantTypeName || "",
              // facilityTypeName:
              //   facilityTypes.find((ft) => ft.facilityTypeID === id)?.facilityTypeName || ""
            }));
    
            setAllReceivingPlants(formattedPlants); // Store all plants
            setPlantList(formattedPlants); // Set initial plant list
            setPlantIdOptions(formattedPlants); // Set initial plant options
          } else if (isMounted) {
            setAllReceivingPlants([]);
            setPlantList([]);
            setPlantIdOptions([]);
          }
        })
        .catch((err) => {
          if (isMounted) {
            console.error(
              "Error fetching receiving plant IDs and storage locations for vendorMosymphonyID = 'all':",
              err
            );
            setAllReceivingPlants([]);
            setPlantList([]);
            setPlantIdOptions([]);
          }
        });
    
      axios
      .get(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPlannerDetails`)
        .then((res) => {
          if (res.data?.status) {
            setPlannerOptions(res.data?.data ? res.data?.data : [])
            setPlannerList(res.data?.data ? res.data?.data : [])
        }
        
      })
      .catch((err) => { console.log(err) });
    
      // setTimeout(() => {
      //   setSelectedCMOList([2, 3]);
      // setSelectedPlantIdList(["L731", "L732", "L731", "L732"]);
      // setSelectedPlannerList([1119, 1120]);
      // }, 2000);
    
    }, []);

  return (
    <Container disableGutters={true} maxWidth={false} className={classes.root}>
      <div
        className={classes.backButton}
        onClick={handleBack}
        style={{ cursor: "default" }} // Prevent cursor on div
      >
        <IconButton size="small" style={{ cursor: "pointer" }}>
          <ArrowBack />
        </IconButton>
        <Typography variant="body1" style={{ cursor: "pointer" }}>
          Back
        </Typography>
      </div>

      <Grid
        container
        className={classes.filterContainer}
        spacing={1}
        alignItems="center"
        style={{ marginTop: "30px" }}
      >
        <Grid
          spacing={2}
          container
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
          }}
        >
          <Grid item>
            <Grid
              container
              spacing={2}
              style={{
                display: "flex",
                // justifyContent: "space-between",
                alignItems: "end",
              }}
            >
              <Grid
                item
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  height: "40px", // Fixed height for the search box
                  // overflow: "hidden", // Prevents resizing issues
                  // width: '30rem',
                }}
              >
                {/* Dropdown inside search bar for selecting field (e.g., COI, Treating Hospitals) */}
                <Box
                  style={{
                    width: "30rem",
                    display: "flex",
                    alignItems: "center",
                    // border: "1px solid black",
                    // height: "40px", // Ensures dropdown doesn't change height
                  }}
                >
                  <TextField
                    size="small"
                    select
                    value={searchField}
                    variant="outlined"
                    onChange={handleSearchField}
                    onKeyDown={(e) => e.key === "Enter" && handleSearchField()}
                    style={{
                      minWidth: 30,
                      border: "1px solid black",
                      borderRight: "none",
                      borderRadius: "0.1rem",
                      backgroundColor: "#F0F0F0",
                      height: "40px",
                    }}
                  >
                    <MenuItem value="all">Select search by</MenuItem>
                    <MenuItem value="PO number">PO Number</MenuItem>
                    <MenuItem value="Product code">Product Code</MenuItem>
                    <MenuItem value="Product description">
                      Product description
                    </MenuItem>
                    <MenuItem value="Plant ID">Plant ID</MenuItem>
                    <MenuItem value="Supply type">Supply type</MenuItem>
                    <MenuItem value="Drug type">Drug type</MenuItem>
                    <MenuItem value="Plant type">Plant type</MenuItem>
                  </TextField>

                  {!["Supply type", "Drug type", "Plant type"].includes(
                    searchField
                  ) && (
                    <TextField
                      size="small"
                      value={searchValue}
                      // onChange={(e) => setSearchValue(e.target.value)}
                      disabled={searchField === "all"}
                      onChange={(e) => {
                        if (searchField !== "all") {
                          handleSearchValue(e);
                        }
                      }} // Update search value on input
                      onKeyDown={(e) =>
                        e.key === "Enter" && handleSearchClick()
                      } // Call API on Enter key
                      variant="outlined"
                      placeholder="Search"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {searchValue && (
                              <Tooltip  aria-label="clear">
                                <Clear
                                  fontSize="small"
                                  onClick={handleClearSearch} // Clear search value
                                  style={{
                                    cursor: "pointer",
                                    color: "dimgray",
                                  }}
                                />
                              </Tooltip>
                            )}
                            <IconButton
                              size="small"
                              style={{
                                backgroundColor: "#EB5E28",
                                color: "white",
                                borderRadius: "0",
                                padding: "8px",
                                translate: "0.84rem",
                              }}
                              onClick={handleSearchClick} // Trigger API call on click
                            >
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      style={{
                        width: "100%",
                        flex: 1,
                        border: "1px solid black",
                        borderRadius: "0.1rem",
                      }}
                    />
                  )}

                  {["Supply type", "Drug type", "Plant type"].includes(
                    searchField
                  ) && (
                    <Autocomplete
                    options={
                        searchField === "Supply type" ?
                        supplyTypes
                          : searchField === 'Drug type' ?
                            drugTypes
                            : searchField === 'Plant type' ?
                              plantTypes
                            : []
                      }
                      getOptionLabel={(option) => {
                        if (searchField === "Supply type") {
                          return option.supplyTypeName
                        } else if (searchField === "Drug type") {
                          return option.drugTypeName
                        } else {
                          return option.plantTypeName
                        }
                      }}
                      value={searchSelectValue || null}
                      onChange={(e, value) => {
                        if (searchField !== "all") {
                          setSearchSelectValue(value)
                          handleSelectTypeValue(value)
                          if (typeof value === 'object') {
                            setSearchValue(searchField === "Supply type" ?
                              String(value.supplyTypeID)
                              : searchField === "Drug type" ?
                              String(value.drugTypeID)
                                : searchField === "Plant type" ?
                                String(value.plantTypeID)
                                : null);
                          } else {
                            setSearchValue('')
                          }
                          
                        }
                      }}
                      style={{
                        width: "100%",
                        flex: 1,
                        border: "1px solid black",
                        borderRadius: "0.1rem",
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          value={searchValue}
                          variant="outlined"
                          placeholder="Search"
                          onChange={(e) => {
                            if (searchField !== "all") {
                              handleSearchValue(e);
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            className: classes.inputBaseRoot,
                            endAdornment: (
                              <InputAdornment position="end">
                                {searchValue && (
                                  <Tooltip
                                    aria-label="clear"
                                  >
                                    <Clear
                                      fontSize="small"
                                      onClick={handleClearSearch} // Clear search value
                                      style={{
                                        cursor: "pointer",
                                        color: "dimgray",
                                      }}
                                    />
                                  </Tooltip>
                                )}
                                <IconButton
                                  size="small"
                                  style={{
                                    backgroundColor: "#EB5E28",
                                    color: "white",
                                    borderRadius: "0",
                                    padding: "8px",
                                    translate: "0.84rem",
                                  }}
                                  onClick={handleSearchClick} // Trigger API call on click
                                >
                                  <SearchIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )} // Disable until PO is selected
                    />
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>

          
          {localStorage.collabType !== "CMO" && (
            <Grid
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: "10px",
                flexDirection: "column",
                marginTop: "1rem",
              }}
            >
              <Grid>
                <Typography style={{ fontWeight: "bold" }}>
                  CMO:
                </Typography>
              </Grid>

              <Grid>
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ width: "12rem", marginRight: "1rem" }}
                >
                  <Select
                    multiple
                    fullWidth
                    size="small"
                    variant="outlined"
                    displayEmpty
                    value={SelectedCMOList.length > 0 ? SelectedCMOList : []} // Fix: Ensures correct initial display
                    onChange={handleChangeCMOList}
                    renderValue={(selected) =>
                      selected.length === 0
                        ? "All"
                        : getDisplayCMOFilterValue()
                    }
                  >
                    <MenuItem value="All">
                      <Checkbox
                        checked={
                          SelectedCMOList.length === cmoMemberWithId.length
                        }
                      />
                      <ListItemText primary="All" />
                    </MenuItem>
                    {cmoMemberWithId.map((option) => {
                      return (
                        <MenuItem key={option} value={option.organization_id}>
                          <Checkbox
                            checked={
                              SelectedCMOList.indexOf(option.organization_id) >
                              -1
                            }
                          />
                          <ListItemText primary={option.organization_name} />
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          )}

          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              flexDirection: "column",
              marginTop: "1rem",
            }}
          >
            <Grid>
              <Typography style={{ fontWeight: "bold" }}>Plant ID:</Typography>
            </Grid>

            <Grid>
              <FormControl
                variant="outlined"
                size="small"
                style={{ width: "12rem", marginRight: "1rem" }}
              >
                <Select
                  multiple
                  fullWidth
                  size="small"
                  variant="outlined"
                  displayEmpty
                  value={
                    selectedPlantIdList.length > 0 ? selectedPlantIdList : []
                  } // Fix: Ensures correct initial display
                  onChange={handleChangePlantIdList}
                  renderValue={(selected) =>
                    selected.length === 0
                      ? "All"
                      : getDisplayPlantIDValue()
                  }
                >
                  <MenuItem value="All">
                    <Checkbox
                      checked={selectedPlantIdList.length === plantList.length}
                    />
                    <ListItemText primary="All" />
                  </MenuItem>
                  {plantList.map((option) => (
                    <MenuItem key={option} value={option.plantCode}>
                      <Checkbox
                        checked={
                          selectedPlantIdList.indexOf(option.plantCode) > -1
                        }
                      />
                      <ListItemText primary={option.plantCode} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              flexDirection: "column",
              marginTop: "1rem",
            }}
          >
            <Grid>
              <Typography style={{ fontWeight: "bold" }}>Planner:</Typography>
            </Grid>

            <Grid>
              <FormControl
                variant="outlined"
                size="small"
                style={{ width: "12rem", marginRight: "1rem" }}
              >
                <Select
                  multiple
                  fullWidth
                  size="small"
                  variant="outlined"
                  displayEmpty
                  value={
                    selectedPlannerList.length > 0 ? selectedPlannerList : []
                  } // Fix: Ensures correct initial display
                  onChange={handleChangePlannerList}
                  renderValue={(selected) =>
                    selected.length === 0
                      ? "All"
                      : getDisplayPlannerValue()
                  }
                >
                  <MenuItem value="All">
                    <Checkbox
                      checked={
                        selectedPlannerList.length === plannerList.length
                      }
                    />
                    <ListItemText primary="All" />
                  </MenuItem>
                  {plannerList.map((option) => {
                    return (
                      <MenuItem key={option} value={option.saasUserID}>
                        <Checkbox
                          checked={
                            selectedPlannerList.indexOf(option.saasUserID) > -1
                          }
                        />
                        <ListItemText primary={option.name} />
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Grid item>
            <Typography
              className={classes.clearFilters}
              onClick={clearFilters}
              // title="Clear all applied filters"
            >
              Clear all filters
            </Typography>
          </Grid>

          <Grid item>
            <Button
              className={classes.button}
              onClick={handleViewReport}
              // title="View the OTIF trend report"
            >
              View report
            </Button>
          </Grid>
        </Grid>
      </Grid>

      <Divider style={{ marginTop: "1rem", marginBottom: "1rem" }} />

      {showReport && (
        <TableContainer component={Paper} >
          <Typography variant="h6" align="center" gutterBottom>
            Average OTIF Trend Report
          </Typography>

          <Table className={classes.table}>
            <TableHead>
              <TableRow className={classes.header}>
                <TableCell>Month</TableCell>
                <TableCell>Year</TableCell>
                <TableCell>OTIF (%)</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    <CircularProgress color="primary" thickness={7} />
                  </TableCell>
                </TableRow>
              ) : error ? (
                 <TableRow
                                  style={{
                                    border: "2px solid rgb(255,0,0)",
                                    backgroundColor: "rgb(255,240,240)",
                                    Opacity: 1,
                                    textAlign: "center",
                                    padding: "0.8rem",
                                    fontSize: "0.875rem",
                                  }}
                                >
                                  <TableCell colSpan={3} align="center">
                                    Something went wrong. Please try again later.
                                  </TableCell>
                                </TableRow>
                
              ) : data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              ) : (
                data.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row.month}</TableCell>
                    <TableCell>{row.year}</TableCell>
                    <TableCell>{Math.round(row.otifPercentage)}</TableCell> 
                    
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};

export default OTIFTrendReport;
